/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusCreateKontaktMessageDto } from '../../models/lexplus-create-kontakt-message-dto';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface KontaktControllerCreateMessageV1$Params {
      body: LexplusCreateKontaktMessageDto
}

export function kontaktControllerCreateMessageV1(http: HttpClient, rootUrl: string, params: KontaktControllerCreateMessageV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, kontaktControllerCreateMessageV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

kontaktControllerCreateMessageV1.PATH = '/v1/kontakt/message';
